import classNames from "classnames";
import React from "react";

export const TableHeader = React.forwardRef<
  HTMLTableSectionElement,
  React.HTMLAttributes<HTMLTableSectionElement>
>(({ className, ...props }, ref) => (
  <thead
    ref={ref}
    className={classNames("g-table__head", className)}
    {...props}
  />
));

TableHeader.displayName = "TableHeader";
